import React from 'react';

export default function MethodSelectStep({ selected, source, onSelect }) {
  const methods = [
    {
      id: 'individual',
      title: 'Individual Migration',
      description: 'Connect to the source server and select users to migrate. Best for accounts with admin/IMAP access.',
      icon: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      )
    },
    {
      id: 'bulk',
      title: 'Bulk Migration (CSV)',
      description: 'Upload a CSV file with user credentials for batch migration. Best for migrating many users at once.',
      icon: (
        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    }
  ];

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Choose Migration Method</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          How would you like to migrate from {source?.name || 'your source'}?
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {methods.map(method => (
          <button
            key={method.id}
            onClick={() => onSelect(method.id)}
            className={`flex flex-col items-center text-center p-6 rounded-xl border-2 transition-all hover:shadow-md ${
              selected === method.id
                ? 'border-orange-500 bg-orange-50 dark:bg-orange-900/20'
                : 'border-gray-200 dark:border-gray-700 hover:border-orange-300'
            }`}
          >
            <div className={`p-3 rounded-full mb-3 ${
              selected === method.id
                ? 'bg-orange-100 text-orange-600 dark:bg-orange-900/40'
                : 'bg-gray-100 text-gray-500 dark:bg-gray-800'
            }`}>
              {method.icon}
            </div>
            <h4 className="font-semibold text-gray-900 dark:text-white">{method.title}</h4>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{method.description}</p>
          </button>
        ))}
      </div>

      {!source?.supportsUserEnum && (
        <div className="flex items-start gap-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm text-blue-700 dark:text-blue-300">
            {source?.name} doesn't support automatic user listing. We recommend using <strong>Bulk Migration (CSV)</strong> to migrate multiple users.
          </p>
        </div>
      )}
    </div>
  );
}
